var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'custom-icon-button',
    {
      'custom-icon-button--active': _vm.active
    }
  ],on:{"click":_vm.onClick}},[(_vm.hasSlot())?[_vm._t("default")]:[_c('b-icon',{staticClass:"custom-icon-button__icon",attrs:{"icon":_vm.icon,"scale":_vm.scale}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }